<template>
  <v-main style="padding-top: 0px;">
    <v-container>
      <v-layout class="justify-center" wrap>
        <v-flex sm12 md12>
          <v-sheet 
            class="pa-2" 
            light
            outlined>

            <v-card-title>
              <v-row class="row-card" v-if="!$vuetify.breakpoint.xs">
                <v-col cols="12" xl="9" md="9">
                  <h3 class="headline">
                    {{ platformName }}
                  </h3>
                </v-col>
                <v-col cols="12" xl="3" md="3" sm="6" xs="6">
                  <v-img 
                    :alt="platformName" 
                    class="mr-3" 
                    contain 
                    height="48px" 
                    position="center right" 
                    :src="require('@/assets/icons/unl.png')">
                  </v-img>
                </v-col>
                
              </v-row>

              <v-row class="row-card"  v-if="$vuetify.breakpoint.xs">
                <v-col cols="12" xs="12" align="center">
                  <v-img 
                    :alt="platformName"  
                    contain 
                    height="96" 
                    width="96"
                    :src="require('@/assets/icons/unl.png')">
                  </v-img>

                  <h3 class="headline">
                    {{ platformName }}
                  </h3>
                </v-col>
              </v-row>
            </v-card-title>

            <v-divider></v-divider>
            
            <v-card-text>
                <label>Complete el siguiente formulario para registrarse en la plataforma:</label>
                  <v-row>
                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        label="Nombre*"
                        type="text"
                        :counter="50"
                        :maxlength="50"
                        v-model="name">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        label="Apellido*"
                        type="text"
                        :counter="50"
                        :maxlength="50"
                        v-model="lastname">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        label="DNI/Pasaporte/Cédula*"
                        type="text"
                        :counter="50"
                        :maxlength="50"
                        v-model="dni"
                        >
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-select
                        v-model="gender_id"
                        :items="[{ id: null, name: 'Seleccione una opción' }, ...genders]"
                        item-value="id"
                        item-text="name"
                        label="Género*"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-select
                        :items="[{ id: null, name: 'Seleccione una opción' }, ...countries]"
                        v-model="country_id"
                        item-text="name"
                        item-value="id"
                        label="Pais*"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12" v-if="country_id==1">
                      <v-select
                        :disabled="country_id==null"
                        :items="[{ id: null, name: 'Seleccione una opción' }, ...provincias]"
                        v-model="provincia_id"
                        v-on:change="getLocalidades"
                        item-text="name"
                        item-value="id"
                        label="Provincia*"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12" v-if="country_id!=1">
                      <v-text-field
                        :disabled="country_id==null"
                        :maxlength="70"
                        :counter="70"
                        :rules="[v => (v || '' ).length <= 199 || 'El nombre del estado/provincia no debe tener mas de 200 caracteres']"
                        ref="other_provincia"
                        v-model="other_provincia"
                        label="Estado/provincia*"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12" v-if="country_id==1">
                      <v-select
                        :disabled="country_id==null"
                        :items="[{ id: null, name: 'Seleccione una opción' }, ...localidades]"
                        v-model="localidad_id"
                        item-text="name"
                        item-value="id"
                        label="Localidad*"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12" v-if="country_id!=1">
                      <v-text-field
                        :disabled="country_id==null"
                        :maxlength="70"
                        :counter="70"
                        :rules="[v => (v || '' ).length <= 199 || 'El nombre de la localidad no debe tener mas de 200 caracteres']"
                        ref="other_localidad"
                        v-model="other_localidad"
                        label="Localidad*"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        label="Carrera o profesión*"
                        type="text"
                        :counter="50"
                        :maxlength="50"
                        v-model="career">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-select
                        v-model="institution_you_are_part"
                        :items="institution_you_are_part_options"
                        item-text="name"
                        item-value="id"
                        label="Empresa o institución de la que sos parte*"
                      />
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        :disabled="institution_you_are_part!=='Otra'"
                        label="Institución de la que proviene*"
                        type="text"
                        :counter="70"
                        :maxlength="70"
                        v-model="institution">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        label="Si tenés un emprendimiento, contanos cómo se llama"
                        type="text"
                        :counter="70"
                        :maxlength="70"
                        v-model="entrepreneurship_name">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        label="Teléfono movil (+cod país + cód área + número)*"
                        type="text"
                        :counter="50"
                        :maxlength="50"
                        v-model="phone_number">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        label="Linkedin"
                        type="text"
                        :counter="100"
                        :maxlength="100"
                        v-model="linkedin">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        label="Facebook"
                        type="text"
                        :counter="100"
                        :maxlength="100"
                        v-model="facebook">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        label="YouTube"
                        type="text"
                        :counter="100"
                        :maxlength="100"
                        v-model="youtube">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        label="Twitter"
                        type="text"
                        :counter="100"
                        :maxlength="100"
                        v-model="twitter">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        label="Instagram"
                        type="text"
                        :counter="100"
                        :maxlength="100"
                        v-model="instagram">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        label="Telegram"
                        type="text"
                        :counter="100"
                        :maxlength="100"
                        v-model="telegram">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        label="Discord"
                        type="text"
                        :counter="100"
                        :maxlength="100"
                        v-model="discord">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        label="Twitch"
                        type="text"
                        :counter="100"
                        :maxlength="100"
                        v-model="twitch">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        label="TikTok"
                        type="text"
                        :counter="100"
                        :maxlength="100"
                        v-model="tiktok">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-text-field
                        outline
                        label="Snapchat"
                        type="text"
                        :counter="100"
                        :maxlength="100"
                        v-model="snapchat">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-select
                        v-model="communication_channel_id"
                        :items="[{ id: null, name: 'Seleccione una opción' }, ...communication_channels]"
                        item-text="name"
                        item-value="id"
                        label="¿Cómo te enteraste de la actividad?*"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-select
                        v-model="completed_studies"
                        :items="completed_studies_options"
                        item-text="name"
                        item-value="id"
                        label="Estudios finalizados*"
                      />
                    </v-col>

                    <v-col cols="12" xl="6" md="6" sm="12">
                      <v-select
                        v-model="receive_information"
                        :items="receive_information_options"
                        item-text="name"
                        item-value="id"
                        label="¿Deseás recibir información?*"
                      />
                    </v-col>

                    <v-col cols="12" class="mt-4">
                      <v-divider></v-divider>
                    </v-col>
                    
                    <v-col cols="12" xl="4" md="4" sm="12">
                      <v-text-field
                        outline
                        label="Correo electrónico*"
                        type="text"
                        :counter="70"
                        :maxlength="70"
                        v-model="email">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="4" md="4" sm="12">
                      <v-text-field
                        outline
                        label="Contraseña*"
                        type="password"
                        :counter="70"
                        :maxlength="70"
                        v-model="password">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" xl="4" md="4" sm="12">
                      <v-text-field
                        outline
                        label="Confirmar contraseña*"
                        type="password"
                        :counter="70"
                        :maxlength="70"
                        v-model="confirm_password">
                      </v-text-field>
                    </v-col>
                  </v-row>
                    
              </v-card-text>

            <v-divider></v-divider>
            <v-card-actions :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }">
            <v-row>
              <v-col cols="12" xl="6" md="6" sm="6" xs="12">
                <v-btn small :to="{ name:'index'}" :block="$vuetify.breakpoint.xs" outlined color="info">
                  Volver
                </v-btn>
              </v-col>
              <v-col cols="12" xl="6" md="6" sm="6" xs="12" class="d-flex justify-end">
                 <v-btn 
                  color="info" 
                  :block="$vuetify.breakpoint.xs" 
                  :large="$vuetify.breakpoint.smAndUp" 
                  :loading="loading_btn"
                  @click="RegisterParticipant()">
                  <v-icon left>lock</v-icon>
                  Regístrarse
                </v-btn>
              </v-col>
            </v-row>
            </v-card-actions>
          </v-sheet>
        </v-flex>
      </v-layout>
    </v-container>

    <v-snackbar
      max-width="440"
      v-model="snackbar"
      :vertical="true"
    >
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="indigo"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="error_dialog"
      persistent
      max-width="490">
      <v-card>
        <v-card-title class="text-h5 font-weight-regular">
          Atención
        </v-card-title>
        <v-card-text>
          <label v-for="error in errors" :key="error" class="mt-8">- {{ error }}<br></label>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="error_dialog = false"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-main>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
   name: 'RegisterParticipant',
   data: () => ({
      dialog:false,
      error_dialog:false,
      loading:true,
      loading_btn: false,
      snackbar:false,
      text:'',
      darkTheme: true,
      platformName:'JIJE UNL',

      slug:null,

      edition_id: null,
      
      name:null,
      lastname:null,
      dni:null,

      gender_id: null,
      genders:[],

      argentina_id: null, 
      country_id: null,
      countries: [],

      other_provincia:null,
      provincia_id: null,
      provincias:[],

      other_localidad:null,
      localidad_id_first:true,
      localidad_id: null,
      localidades:[],

      participant_type: 'Asistente',
      participant_type_options: [    
        'Asistente',
        'Expositor',
        'Organizador'
      ],

      institution:null,
      career:null,

      institution_you_are_part: null,
      institution_you_are_part_options: [
        { id: null, name: 'Seleccione una opción' },
        { id: 'Foro de Capital', name: 'Foro de Capital' },
        { id: 'Estudiante de grado UNL', name: 'Estudiante de grado UNL' },
        { id: 'Incubados IDEAR', name: 'Incubados IDEAR' },
        { id: 'Incubados Expresiva', name: 'Incubados Expresiva' },
        { id: 'Incubados PTLC', name: 'Incubados PTLC' },
        { id: 'Gabinetes para Emprendedores UNL', name: 'Gabinetes para Emprendedores UNL' },
        { id: 'Proyectos UNL BIO', name: 'Proyectos UNL BIO' },
        { id: 'Docentes de Cátedras Electivas de Emprendedores UNL', name: 'Docentes de Cátedras Electivas de Emprendedores UNL' },
        { id: 'UTID', name: 'UTID' },
        { id: 'Otra', name: 'Otra' }
      ],

      entrepreneurship_name:null,
      phone_number:null,
      whatsapp:null,
      telegram:null,
      linkedin:null,
      facebook:null,
      youtube:null,
      twitter:null,
      instagram:null,
      discord:null,
      twitch:null,
      tiktok:null,
      snapchat:null,

      communication_channel_id:null,
      communication_channels:[],

      completed_studies: null,
      completed_studies_options: [
        { id: null, name: 'Seleccione una opción' },
        { id: 'Secundario incompleto', name: 'Secundario incompleto o en curso' },
        { id: 'Secundario completo', name: 'Secundario completo' },
        { id: 'Terciario incompleto', name: 'Terciario incompleto o en curso' },
        { id: 'Terciario completo', name: 'Terciario completo' },
        { id: 'Universitario incompleto', name: 'Universitario incompleto o en curso' },
        { id: 'Universitario completo', name: 'Universitario completo' },
        { id: 'Posgrado incompleto', name: 'Posgrado incompleto' },
        { id: 'Posgrado completo', name: 'Posgrado completo' },
        { id: 'Otro', name: 'Otro' }
      ],

      receive_information: null,
      receive_information_options: [
        { id: null, name: 'Seleccione una opción' },
        { id: 'Si', name: 'Sí' },
        { id: 'No', name: 'No' }
      ],

      email:null,
      password:null,
      confirm_password:null,

      emailRules: [ 
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v),
        v => this.validate(v)
      ],
      passwordRules: [ 
          v => !!v || "El campo es requerido",
          v => ( v && v >= 5 ) || "La contraseña debe tener al menos 5 caracteres",
          v => ( v && v <= 25 ) || "La contraseña no debe tener mas de 50 caracteres",
      ],

      error:'',
      errors:[],
      
      convocation:[]
    }),
    computed: {
    ...mapGetters([
      'isLogged', 'user'
      ])
    },
    watch: {
      provincia_id: {
        handler: function() {
          this.localidad_id_first = true
            this.getLocalidades(); // call it in the context of your component object
        }
      }
    },
    methods: {
      async getCountries(){
        try {
          await axios.get('countries').then(response =>{
            this.countries = response.data.data.countries
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getProvincias(){
        try {
          await axios.get('provincias').then(response =>{
            this.provincias = response.data.provincias
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getLocalidades(){
        try {
          await axios.get('provincias-localidades/'+this.provincia_id).then(response =>{
            this.localidades = response.data.provincia.localidads
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getChannelsComunication(){
        try {
          await axios.get('comunication-channels').then(response =>{
            this.communication_channels = response.data.data.comunication_channels
            this.loading=false
          }).catch(error => {
            console.log(error)
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getInfoEdition(){
        await axios.get('index/convocation/'+this.slug).then(response =>{
          if(!response.data.convocation){
            this.$router.push({ name: 'HandleConvocationLogin' })   
            this.loading=false
          }else{
            this.edition_id = response.data.convocation.id
            this.convocation = response.data.convocation
            this.loading=false
          }
          
        }).catch(error => {
          console.log(error)
          if(error.response.status===404){
            this.$router.push({ name: 'index' })  
          }
        })
      },

      async getGenders(){
        try {
          await axios.get('genders').then(response =>{
            if(response.data.length!==0){
              this.genders = response.data.genders
            }
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async RegisterParticipant() {
        this.loading_btn = true;

        try {
            const response = await axios.post('/register-participant', { 
              edition_id: this.edition_id,
              name: this.name,
              lastname: this.lastname,
              dni: this.dni,
              gender_id: this.gender_id,
              country_id: this.country_id,
              provincia_id: this.provincia_id,
              other_provincia: this.other_provincia,
              localidad_id: this.localidad_id,
              other_localidad: this.other_localidad,
              participant_type: this.participant_type,
              institution: this.institution,
              career: this.career,
              institution_you_are_part: this.institution_you_are_part,
              entrepreneurship_name: this.entrepreneurship_name,
              phone_number: this.phone_number,
              linkedin: this.linkedin,
              facebook: this.facebook,
              youtube: this.youtube,
              twitter: this.twitter,
              instagram: this.instagram,
              telegram: this.telegram,
              discord: this.discord,
              twitch: this.twitch,
              tiktok: this.tiktok,
              snapchat: this.snapchat,
              communication_channel_id: this.communication_channel_id,
              completed_studies: this.completed_studies,
              receive_information: this.receive_information,
              email: this.email,
              password: this.password,
              confirm_password: this.confirm_password
            });

            console.log('Respuesta del servidor: ', response.data);

            this.text = 'Gracias por registrarte, ahora ya puedes iniciar sesion.';
            this.snackbar = true;
            this.loading_btn = false;

            setTimeout(() => {
                this.$router.push({ name: 'login' }) 
            }, 2000);

        } catch (error) {
            this.text = error.response.data.error;

            this.errors = []
            if(error.response.data.errors){
                for (const key in error.response.data.errors) {
                    this.errors.push(error.response.data.errors[key][0])
                }
            }else{
                this.errors.push(error.response.data.error)
            }

            this.loading_btn = false;
            this.error_dialog = true;
        }
      },

      cheakIsLogin() {
        if (this.isLogged) {
          this.loading = false;
          if (
            this.user &&
            typeof this.user === 'object' &&
            Array.isArray(this.user.roles) &&
            this.user.roles.includes('admin')
          ) {
            this.$router.push({ name: 'editions' })
          } else {
            this.$router.push({ name: 'HandleConvocationLogin' })
          }
        }
      },

      validateSlugEmpty(){
        if(!this.slug){
          this.$router.push({ name: 'UNLPotencia' })  
        }
      },

      async initData() {
        try {
          this.slug = this.$route.params.slug;
          window.scrollTo(0, 0);

          await this.validateSlugEmpty();
          await Promise.all([
            this.getInfoEdition(),
            this.getChannelsComunication(),
            this.getCountries(),
            this.getProvincias(),
            this.getGenders()
          ]);

          this.loading = false;
        } catch (error) {
          console.error(error);
        }
      }
  },

  created() {
    this.cheakIsLogin();

    // Si cheakIsLogin redirige, evitamos continuar
    if (this.isLogged) return;

    // Ejecutar el resto de funciones en orden
    this.initData();
  }
};
</script>